import { InputBase, styled } from '@mui/material'
import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { useDebouncedTextInput } from './useDebouncedTextInput'

type EmailCellProps = {
  value: string | undefined
  onChange?: (v: string | undefined) => void
} & CellPropsBase

// メール専用セル。入力の仕組みは TextCell と共通だが、メール固有の要件
// （全角不可・メール形式）をこのセルと EMAIL バリデーションに閉じ込めるため、
// 汎用 TextCell に分岐を足さずに別コンポーネントとして分離している。
export const EmailCell = ({
  label,
  help,
  placeholder,
  cellWidth,
  value,
  onChange,
  editable = true,
  required = false,
  edited,
  validationErrors,
}: EmailCellProps) => {
  const { inputValue, onChangeInput } = useDebouncedTextInput(value, onChange)

  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <EmailInput
          value={inputValue}
          onChange={onChangeInput}
          disabled={!editable}
          placeholder={placeholder}
          type="email"
          inputMode="email"
        />
      </CellValueArea>
    </FormCell>
  )
}

const EmailInput = styled(InputBase)({
  width: '100%',
})
